module.exports = __webpack_public_path__ + "img/jbt8010-6a.asm.f880813e.jpg";